import getHost from 'utils/getHost';
import Environments from 'constants/Environments';

export default () => {
  const host = getHost();

  return (
    host.includes(Environments.STAGING.vercelHost) ||
    host === Environments.STAGING.host
  );
};
